import React, { Component } from 'react';
import _ from 'lodash';
import shared from '../../../utils/shared.js';
import Moment from 'react-moment';

const backSvg = require('../../../../public/img/ui/back.svg');
const forwardSvg = require('../../../../public/img/ui/forward.svg');
const closeSvg = require('../../../../public/img/ui/close.svg');
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class StoryAnnouncement extends Component {
  constructor(props) {
    super(props);
    this._normalFontSize = .01 * this.props.screen.screenWidth;
    this._hugeFontSize = .026 * this.props.screen.screenWidth;
    this.state = {}
  }

  componentDidMount() {
    this.setupStory();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setupStory();
    }
  }

  setupStory = () => {
    let richTextFields = ['paragraph'];
    let fieldsValues = {}
    let slideshowModule = {};
    let slideIndex = _.get(this.props.story, 'contents.custom_fields.slideshow.child_val.value', 0);
    let textColor = "#000000";
    let background = null;
    let backgroundImage = null;
    let birthday = _.get(this.props.story, 'contents.custom_fields.date_of_birth.val', null);
    let image = null;
    let imageObj = null;

    for (let i = 0; i < richTextFields.length; i++) {
      let fieldName = richTextFields[i];
      let textOps = _.get(this.props.story.contents, 'custom_fields['+fieldName+'].val.ops', _.get(this.props.story.contents, 'custom_fields['+fieldName+'].default.ops', null));
      let converter = new QuillDeltaToHtmlConverter(textOps, {});
      let richText = converter.convert();
      fieldsValues[fieldName] = richText;
    }
    
    let slideshowId = _.get(this.props.story, 'contents.custom_fields.slideshow.val.value', null);
    if (slideshowId !== null) {
      slideshowModule = _.find(this.props.otherModules, { id: slideshowId, display_module_type: "Slideshow" });
      if (slideshowModule) {
        textColor = _.get(slideshowModule, 'contents.color0s['+slideIndex+']', '#000000');
        background = _.get(slideshowModule, 'contents.images['+slideIndex+']', null);
        imageObj = _.get(this.props.story, 'contents.images[0]', null);
        if (background) {
          backgroundImage = this.getBackground(background);
        }
        if (imageObj) {
          image = this.getBackground(imageObj);
        }
      }
    }

    this.setState({
      ...fieldsValues,
      background: backgroundImage,
      textColor: textColor,
      image: image,
      birthday: birthday,
      line_1: _.get(this.props.story, 'contents.custom_fields.line_1.val', null),
      baby_name: _.get(this.props.story, 'contents.custom_fields.baby_name.val', null),
    });
  }

  getBackground = (displayImage) => {
    if (displayImage) {
      return shared.dp(this.props.screen, displayImage, null);
    }
    return null;
  }

  navarea() {
    return (
      <div style={{ position: 'absolute', width: this.props.width, height: this.props.height - this.props.width / 2, bottom: 0, backgroundColor: '#424958' }}>
        <div style={{ display: 'inline-flex', alignItems: "center", width: '100%', height: '100%' }}>
          <span style={{ width: '50%' }}>
            <img alt="back" onClick={() => this.props.cycleStory("backward")} style={{ marginLeft: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .024 }} src={backSvg} />
            <img alt="forward" onClick={() => this.props.cycleStory("forward")} style={{ marginLeft: this.props.width * .03, width: this.props.width * .024, height: this.props.width * .024 }} src={forwardSvg} />
          </span>
          <span style={{ width: '50%', textAlign: 'right' }}>
            <img alt="close" onClick={() => this.close()} style={{ marginRight: this.props.width * .02, width: this.props.width * .024, height: this.props.width * .04 }} src={closeSvg} /></span>
        </div>
      </div>
    )
  }

  close() {
    this.props.closeStory();
  }

  render() {
    let type = _.get(this.props.story, 'contents.custom_fields.story_type.val.value', null);
    if (!type || type !== 'baby_announcement') {
      return (<span/>);
    }
    let navarea = this.navarea();
    let backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    let outerDivStyle = {};
    if (this.props.modal) {
      backgroundSize = `${this.props.width}px ${this.props.height}px`;
      outerDivStyle = {
        top: this.props.top,
        left: this.props.left,
        height: this.props.height,
        width: this.props.width,
        position: "absolute"
      }
    } else {
      outerDivStyle = {
        top: 0,
        left : 0,
        height: this.props.screen.screenHeight,
        width: this.props.screen.screenWidth
      }
    }
    return (
        <div style={{ position: "absolute", ...outerDivStyle, pointerEvents: 'auto', overflow: "hidden" }}>
          <div style={{ backgroundImage: `url(${this.state.background})`, backgroundSize: backgroundSize, height:outerDivStyle.height, width: outerDivStyle.width, textAlign:"center", position:"absolute" }}>
            {/* Line 1 */}
            <div style={{ marginTop: "1.30vw", display:"flex", justifyContent:"center", position:"relative", width:"100%", textAlign:"center" }} className="ql-editor">
              <div style={{  maxWidth:"35vw", color: this.state.textColor }}>
                <span className="ql-size-24px">{this.state.line_1}</span>
              </div>
            </div>

            {/* Line2 */}
            <div style={{ marginTop: "1.30vw", display:"flex", justifyContent:"center", position:"relative", width:"100%", textAlign:"center" }} className="ql-editor">
              <div style={{ maxWidth:"35vw", color: "#505052" }}>
                <em className="ql-size-20px">Joyfully Welcomes</em>
              </div>
            </div>

            {/* Baby Name */}
            <div style={{ marginTop: "1.30vw", display:"flex", justifyContent:"center", position:"relative", width:"100%", textAlign:"center" }} className="ql-editor">
              <div style={{ maxWidth:"35vw", color: this.state.textColor }}>
              <span className="ql-size-24px">{this.state.baby_name}</span>
              </div>
            </div>

            {/* Birth Day */}
            <div style={{ marginTop: "1.30vw", display:"flex", justifyContent:"center", position:"relative", width:"100%", textAlign:"center" }} className="ql-editor">
              <div style={{ maxWidth:"35vw", color: "#505052", fontStyle: "italic", fontSize:"1.45vw" }}>
                <Moment format="MMMM Do YYYY, h:mm:ss a">
                  {this.state.birthday}
                </Moment>
              </div>
            </div>

            {/* Image */}
            <div>
              <img alt="announcement" style={{ marginTop: "1.30vw", maxWidth:"30vw", maxHeight:"16.87vw" }} src={this.state.image}/>
            </div>

            {/* Paragraph */}
            <div style={{ marginTop: "1.30vw", display:"flex", justifyContent:"center", position:"relative", width:"100%", textAlign:"center" }} className="ql-editor">
              <div style={{ lineHeight:"1.9vw", maxWidth:"35vw", color: "#505052" }} dangerouslySetInnerHTML={{ __html: this.state.paragraph }}/>
            </div>
          </div>
          { this.props.modal ? navarea : null }
        </div>
    );
  }
}

export default StoryAnnouncement;



// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/StoryAnnouncement.js